import { Observable } from 'rxjs';
import { KlarnaSessionStartResponseModel, KlarnaSessionCompleteRequestModel, KlarnaSessionTerminateRequestModel } from 'src/app/models/klarna.model';
import { KLARNA_SESSION_START, KLARNA_SESSION_COMPLETE, KLARNA_SESSION_TERMINATE} from 'src/app/app.consts';
import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'src/app/services/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class KlarnaApi extends BaseApiService {
  constructor(private http: HttpClient, protected auth: AuthService, private translate: TranslateService) {
    super(auth);
  }

  sessionStart(applicationId: number): Observable<KlarnaSessionStartResponseModel> {
    const payload = {
      language: this.translate.currentLang,
      applicationId
    };

    return this.http.post<KlarnaSessionStartResponseModel>(`${this.apiUrl}${KLARNA_SESSION_START}`, payload, this.authHeader);
  }

 sessionComplete(payload: KlarnaSessionCompleteRequestModel): void {
    this.http.post(`${this.apiUrl}${KLARNA_SESSION_COMPLETE}`, payload, this.authHeader).subscribe();
  }

  sessionTerminate(payload: KlarnaSessionTerminateRequestModel): void {
    this.http.post(`${this.apiUrl}${KLARNA_SESSION_TERMINATE}`, payload, this.authHeader).subscribe();
  }
}
